import React, { useEffect, useRef, useState } from "react";

const ITEMS = [
    "Lead captured → CRM updated → follow-up sent · 4 sec",
    "Invoice logged → receipt filed → books reconciled · 6 sec",
    "Applicant screened → viewing booked → reminder set · 3 sec",
];

function Segment({ innerRef }) {
    return (
        <span ref={innerRef} className="inline-flex items-center">
            {ITEMS.map((t, i) => (
                <span key={i} className="inline-flex items-center">
                    <span className="px-6 font-mono-t text-[0.8rem] sm:text-sm text-muted-foreground">{t}</span>
                    <span className="text-muted-foreground/50">···</span>
                </span>
            ))}
        </span>
    );
}

// Seamless at all widths: one half of the track holds enough segment copies to
// exceed the viewport, the track holds two identical halves, and it translates
// exactly one half (-50%) before looping, so the reset point is invisible.
export function Ticker() {
    const segRef = useRef(null);
    const [copies, setCopies] = useState(3);

    useEffect(() => {
        const compute = () => {
            const segW = segRef.current?.offsetWidth || 800;
            const need = Math.ceil(window.innerWidth / segW) + 1;
            setCopies(Math.max(2, need));
        };
        compute();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(compute);
        window.addEventListener("resize", compute);
        return () => window.removeEventListener("resize", compute);
    }, []);

    const half = Array.from({ length: copies });
    const duration = copies * 22; // calm, consistent speed regardless of copy count

    return (
        <section data-testid="ticker" className="border-y border-border bg-surface overflow-hidden">
            <div className="py-3.5 relative">
                <div className="marquee-track" style={{ animationDuration: `${duration}s` }}>
                    {half.map((_, i) => (
                        <Segment key={`a${i}`} innerRef={i === 0 ? segRef : undefined} />
                    ))}
                    {half.map((_, i) => (
                        <Segment key={`b${i}`} />
                    ))}
                </div>
            </div>
        </section>
    );
}
